module.exports = __webpack_public_path__ + "static/media/Arc Warden.175a3fa1.png";